import { useRevealAnimation } from "@/motion/hooks";
import { useState } from "react";

// Official brand logos live in /app/frontend/public/brands/
const BRANDS = [
    { name: "LOTTO Sport US", file: "/brands/logo-lotto.webp" },
    { name: "SPARX", file: "/brands/logo-sparx.webp" },
    { name: "Cherrapunji Gin", file: "/brands/logo-cherrapunji.webp" },
    { name: "Maggi", file: "/brands/logo-maggi.webp" },
    { name: "Tanishq", file: "/brands/logo-tanishq.png" },
];

function LogoChip({ name, file }) {
    const [failed, setFailed] = useState(false);
    return (
        <div
            data-testid={`brand-slot-${file.split("/").pop()}`}
            className="flex h-16 w-40 md:h-20 md:w-52 items-center justify-center rounded-md bg-[#f4efe6] px-5 opacity-85 grayscale transition-all duration-500 hover:opacity-100 hover:grayscale-0"
        >
            {failed ? (
                <span className="font-display text-lg tracking-wide text-black/70 whitespace-nowrap">
                    {name}
                </span>
            ) : (
                <img
                    src={file}
                    alt={`${name} logo`}
                    onError={() => setFailed(true)}
                    className="max-h-9 md:max-h-11 w-auto max-w-full object-contain"
                    loading="lazy"
                />
            )}
        </div>
    );
}

export default function BrandStrip() {
    const logosReveal = useRevealAnimation("maskReveal", { children: "img", stagger: "tight" });
    return (
        <section ref={logosReveal}
            data-testid="brand-strip"
            className="relative border-y border-[color:var(--line)] bg-[#030303] py-14 md:py-16"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10">
                <p className="text-center text-[10px] uppercase tracking-luxe text-[color:var(--muted)]">
                    Brands I&apos;ve created for
                </p>
                <div className="mt-10 flex flex-wrap items-center justify-center gap-5 md:gap-7">
                    {BRANDS.map((b) => (
                        <LogoChip key={b.file} {...b} />
                    ))}
                </div>
            </div>
        </section>
    );
}
